export default __webpack_public_path__ + "static/media/enter_otp.fac83043.png";